import { useEffect } from "react";
import api, { API } from "@/lib/api";
import { logger } from "@/lib/logger";

/**
 * Applies the active /api/branding settings to <title> and the favicon link.
 * Runs once on mount + every 60s in case branding gets updated in another tab.
 */
export default function useBrandingTitleAndFavicon() {
  useEffect(() => {
    let cancelled = false;
    const apply = async () => {
      try {
        const { data } = await api.get("/branding");
        if (cancelled || !data) return;
        const name = (data.app_name || "Happy Retreats Ops").trim();
        if (document.title !== name) document.title = name;
        const logoPath = data.logo_url || data.logo_path;
        if (logoPath) {
          const href = `${API}/files?path=${encodeURIComponent(logoPath)}`;
          let link = document.querySelector("link[rel='icon']");
          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
          }
          if (link.href !== href) link.href = href;
        }
      } catch (e) {
        // /branding may 401 pre-login — only log non-auth failures
        if (e?.response?.status && e.response.status !== 401) {
          logger.warn("Branding fetch failed:", e);
        }
      }
    };
    apply();
    const t = setInterval(apply, 60000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);
}
